import React, {useState} from "react";
import "./Showroom.scss";
import {Menu, Dropdown, Button} from "antd";
import {useHistory} from "react-router";
import "antd/dist/antd.css";
import ProductCut from "./ProductCut";
import ModelCut from "./ModelCut";
import ModelCutDetails from "./ModelCutDetails";
import Footer from "./Footer";
import queryString from "query-string";
const {SubMenu} = Menu;

function Showroom(props) {
    // const [visible, setVisible] = useState(false);
    const history = useHistory();
    let queries = queryString.parse(props.location.search);

    const [brandName, setBrandName] = useState(queries.brandName);

    //BRAND NAMES FROM ADMIN
    const menu = (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key="Men">Men</Menu.Item>
            {/* <SubMenu title="Women" key="women">
                <Menu.Item key="thisisververthat">thisisververthat</Menu.Item>
                <Menu.Item key="unaffected">unaffected</Menu.Item>
                <Menu.Item key="recto man">recto man</Menu.Item>
                <Menu.Item key="lab101">lab101</Menu.Item>
            </SubMenu> */}
            <Menu.Item key="Women">Women</Menu.Item>
            <Menu.Item key='Acc. "&amp;" Bag'>Acc. "&amp;" Bag</Menu.Item>
        </Menu>
    );

    function handleMenuClick(e) {
        console.log("click", e.key);
        setBrandName(e.key);
    }

    let modelDetails = [
        {image: "1.jpg", lookNo: 1},
        {image: "2.jpg", lookNo: 2},
        {image: "3.png", lookNo: 3},
        {image: "4.jpg", lookNo: 4},
        {image: "5.png", lookNo: 5},
    ];
    const modelResult = modelDetails.find(
        (obj) => obj.lookNo == queries.lookNo
    );

    let productDetails = [
        {
            image: "6.jpg",
            brandName: "RECTO",
            productName: "Half-cut out blazer",
            modelNum: "AFEFXCGVGHS20",
            price: "450.0",
        },
        {
            image: "6.jpg",
            brandName: "RECTO",
            productName: "Half-cut out blazer",
            modelNum: "AFEFXCGVGHS20",
            price: "450.0",
        },
        {
            image: "6.jpg",
            brandName: "RECTO",
            productName: "Half-cut out blazer",
            modelNum: "AFEFXCGVGHS20",
            price: "450.0",
        },
        {
            image: "6.jpg",
            brandName: "RECTO",
            productName: "Half-cut out blazer",
            modelNum: "AFEFXCGVGHS20",
            price: "450.0",
        },
    ];

    const categoryList = [
        {
            category: "WOMEN’S ADVANCED",
            brandNames: ["KIMHEKIM", "MIN JU KIM"],
        },
        {
            category: "WOMEN'S CONTEMPORARY",
            brandNames: ["AMOMENTO", "GU_DE", "J KOO", "KIJUN", "RECTO"],
        },
        {
            category: "WOMEN'S CONTEMPORARY",
            brandNames: ["AMOMENTO", "GU_DE", "J KOO", "KIJUN", "RECTO"],
        },
        {
            category: "BAG / SHOED & ACCESORRY",
            brandNames: [
                "COMME SE-A",
                "GU_DE",
                "ISABELLA ETOU",
                "PROJEKT PRODUKT",
                "YY by YUUL YIE",
            ],
        },
    ];

    const footerButton = [
        {name: "LOGIN TO JOOR", link: ""}, //JOOR LINK FROM ADMIN
        {name: "APPOINTMENT BOOKING", link: "calendar"},
        {name: "DOWNLOAD LINESHEET", link: ""}, //DOWNLOAD EXCEL FILE
        {name: "DOWNLOAD LOOKBOOK", link: ""}, //DOWNLOAD PDF FILE
    ];

    // const toggleVisible = () => {
    //     const scrolled = document.documentElement.scrollTop;
    //     if (scrolled > 100) {
    //         setVisible(true);
    //     } else if (scrolled <= 100) {
    //         setVisible(false);
    //     }
    // };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    // window.addEventListener("scroll", toggleVisible);

    return (
        <div>
            <div className="Header">
                <div className="FirstRow">
                    <div className="Logo">
                        <img
                            src="/Images/Showroom/ideal_logo.svg"
                            onClick={() => history.push("/digitalshowroom")}
                            style={{cursor: "pointer"}}
                        ></img>
                    </div>
                    <div className="BrandsFilter">
                        <Dropdown overlay={menu}>
                            <Button className="ButtonDD">
                                SHOWROOM BRANDS
                                <i class="fas fa-sort-down"></i>
                            </Button>
                        </Dropdown>
                    </div>
                    <div className="RightDiv">
                        <a className="LoginText" href="#">
                            Logout
                        </a>
                        <span>|</span>
                        {/* LOGOUT USER AND GIVE PATH TO DIGITAL SHOWROOM PAGE */}
                        <a className="AppointmentText" href="/Calendar">
                            Appointment
                        </a>
                    </div>
                </div>
                <div className="Nevigation">
                    {/* PATH TO DIGITAL SHOWROOM PAGE */}
                    <a className="Routes" href="/digitalshowroom">
                        Home
                    </a>

                    {brandName != null && (
                        <>
                            {/*  LINK TO CORRESPONDING BRAND ROOM PAGE */}
                            <i class="fas fa-angle-right"></i>
                            <a
                                className="Routes"
                                href={`/Showroom?brandName=${brandName}`}
                            >
                                {brandName}
                            </a>
                            {queries.lookNo && (
                                <>
                                    <i class="fas fa-angle-right"></i>
                                    <a className="Routes" href="#">
                                        LOOK#{queries.lookNo}
                                    </a>
                                </>
                            )}
                        </>
                    )}
                </div>

                <div className="ThirdRow"></div>
            </div>
            {window.location.pathname == "/showroom/modelCutDetails" ? (
                <div>
                    <ModelCutDetails details={modelResult} />
                </div>
            ) : (
                <>
                    <div
                        className="ImageContainer"
                        style={{
                            background: `url(Images/Showroom/showroomBack.jpg)`,
                            width: "100%",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                        }}
                    >
                        <div className="BrandText">{brandName}</div>
                    </div>

                    <div className="ModelCutList">
                        <ModelCut
                            modelDetails={modelDetails}
                            brandName={brandName}
                        />
                    </div>

                    <div className="ProductsCut">
                        <ProductCut productDetails={productDetails} />
                    </div>
                </>
            )}
            <div className="Footer">
                <Footer
                    categoryList={categoryList}
                    footerButton={footerButton}
                />
            </div>

            <button
                class="ScrollToTopBtn"
                onClick={scrollToTop}
                // style={{display: visible ? "inline" : "none"}}
            >
                <i class="fas fa-angle-up"></i>
            </button>
        </div>
    );
}

export default Showroom;
